export const MIN_PERSON_VALUE = 1000000;
export const MAX_PERSON_VALUE = 49999999;
export const MIN_COMPANY_VALUE = 50000000;
export const MAX_COMPANY_VALUE = 99999999;
